// import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
// import * as types from '../mutation-types'
// import router from '../../router'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const state = {
  cart: {
    cartId: '',
    items: []
  }
}
const getters = {
  // returns the filltered wishList content
  getCartDataMatchingKeyWord: (state, getters) => keyWord => {
    var result = []
    if (keyWord.length === 0) {
      result = state.cart.items
      // result = getters.getCartData.items
    } else {
      // console.log(123)
      result = getters.getCartData.items.filter(obj => {
        // console.log(JSON.stringify(obj.itemName), obj.itemName.toLowerCase().includes(keyWord.toLowerCase()))
        return obj.itemName.toLowerCase().includes(keyWord.toLowerCase())
      })
    }
    return result
  },
  // return true if item present in cart else false if not present
  itemPresentInCartStatus: (state, getters) => itemId => {
    for (var j = 0; j < getters.getCartData.items.length; j++) {
      if (getters.getCartData.items[j].itemId === itemId) {
        return true
      }
    }
    return false
  },
  getCartData: state => {
    // swal('hello there')
    return state.cart
  }
}
const mutations = {
  setCartData (state, data) {
    // data.items.forEach(element => {
    //   var isExist = false
    //   state.cart.items.forEach(element1 => {
    //     if (element1.itemId === element.itemId) {
    //       console.log(element1.itemId)
    //       isExist = true
    //     }
    //   })
    //   if (!isExist) {
    //     console.log('n h')
    //     state.cart.items.push(element)
    //   } else {
    //     console.log('here')
    //     state.cart.items.forEach(ele => {
    //       if (ele.itemId === element.itemId) {
    //         console.log('s', ele.itemId, '===', element.itemId)
    //         ele.amount = element.amount
    //       }
    //     })
    //   }
    // })
    state.cart.items = data.items
    state.cart.cartId = data.cartId
  },
  addTocart (state, data) {
    var isExist = false
    if (state.cart.items.length !== 0) {
      state.cart.items.forEach(element1 => {
        if (element1.itemId === data.itemId) {
          isExist = true
        }
      })
    }
    if (!isExist) {
      state.cart.push(data)
    }
  },
  deleteFromCart (state, data) {
    var temp = state.cart.items
    state.cart.items = []
    if (temp.length !== 0) {
      temp.forEach(element => {
        if (element.itemId !== data.itemId) {
          state.cart.items.push(element)
        }
      })
    }
  },
  clearCartData (state) {
    state.cart = {
      cartId: null,
      items: []
    }
  },
  resetCartItems (state) {
    state.cart.items = []
  }
}
const actions = {
  previousCartItems (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/getCartItems', data)
        .then(res => {
          if (res.data !== null) {
            resolve(res.data)
          }
        })
        .catch(err => {
          console.log('error viewing::', err)
          reject(err)
        })
    })
  },
  viewCartData (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/cartView', {
        'profileId': data
      })
        .then(res => {
          if (res.data !== null) {
            context.commit('setCartData', res.data)
            resolve()
          }
        })
        .catch(err => {
          console.log('error viewing::', err)
          reject(err)
        })
    })
  },
  deleteData (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/cartDelete', {
        'profileId': data.profileId,
        'itemId': data.itemId,
        'cartId': data.cartId
      })
        .then(res => {
          context.commit('deleteFromCart', data)
          resolve()
        })
        .catch(err => {
          console.log('error deleting', err)
          reject(err)
        })
    })
  },
  addCartData (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/cartAdd', {
        'profileId': data.profileId,
        'itemId': data.itemId,
        'cartId': data.cartId
      })
        .then(res => {
          context.commit('setCartData', res.data)
          // context.dispatch('viewCartData', data.profileId)
          resolve()
        })
        .catch(err => {
          console.log('error Inserting', err)
          reject(err)
        })
    })
  },
  clearCartItemsInStore (context) {
    context.commit('resetCartItems')
  }
}
export default {
  state,
  getters,
  mutations,
  actions,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js